import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

export type CenteredContentProps = HTMLAttributes<HTMLDivElement>;

/**
 * CenteredContent - Container for centering content with consistent max-width
 *
 * Applies a fixed max-width of 996px and centers the content horizontally.
 * Use className prop to add padding or other styles.
 *
 * @example
 * <CenteredContent className="px-10 pb-10">
 *   {content}
 * </CenteredContent>
 */
export function CenteredContent({ children, className, ...props }: CenteredContentProps) {
  return (
    <div className={clsx('max-w-249 mx-auto', className)} {...props}>
      {children}
    </div>
  );
}
